export class ELKFormatter {
    appInfo;
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(appInfo) {
        this.appInfo = appInfo;
    }
    format(log) {
        const elkAppInfo = {
            runtime: 'browser',
            application: this.appInfo.application,
            mcs_run_env: this.appInfo.mcsRunEnv,
            version: this.appInfo.version,
            href: this.appInfo.href,
            available_screen_size: this.appInfo.availableScreenSize,
            screen_size: this.appInfo.screenSize,
        };
        return JSON.stringify(Object.assign(elkAppInfo, log));
    }
}
//# sourceMappingURL=ELKFormatter.js.map